import * as React from 'react';
import FedexLogo from '@narvar/nth-fedex-logo';
import WalgreensLogo from '../../WalgreensLogo';
import LocationIcon from '../../LocationIcon';

interface Props {
  providerId: string;
  s?: React.CSSProperties;
}

const LocationLogo: React.FunctionComponent<Props> = ({
  providerId,
  s,
}: Props) => {
  switch (providerId) {
    case 'walgreens':
      return <WalgreensLogo s={s} />;
    case 'fedex':
      return <FedexLogo s={s} />;
    default:
      return <LocationIcon s={s} />;
  }
};

export default LocationLogo;
